import { render, staticRenderFns } from "./order-form-property-wig-fullness.vue?vue&type=template&id=29052b94&scoped=true"
import script from "./order-form-property-wig-fullness.vue?vue&type=script&lang=js"
export * from "./order-form-property-wig-fullness.vue?vue&type=script&lang=js"
import style0 from "./order-form-property-wig-fullness.vue?vue&type=style&index=0&id=29052b94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29052b94",
  null
  
)

export default component.exports